import React from 'react';
import { motion } from 'framer-motion';

const BackgroundBlobs = () => {
  return (
    <>
      {/* Cosmic Teal Blob */}
      <motion.div
        className="absolute w-72 h-72 rounded-full blur-[80px] opacity-20 mix-blend-multiply pointer-events-none"
        style={{ backgroundColor: '#0A9396' }}
        animate={{
          x: [0, 30, 0],
          y: [0, 50, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        initial={{ top: '10%', left: '10%' }}
      />
      
      {/* Amethyst Blob */}
      <motion.div
        className="absolute w-80 h-80 rounded-full blur-[80px] opacity-20 mix-blend-multiply pointer-events-none"
        style={{ backgroundColor: '#9D4CDD' }}
        animate={{
          x: [0, -40, 0],
          y: [0, 60, 0],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        initial={{ bottom: '20%', right: '10%' }}
      />
    </>
  );
};

export default BackgroundBlobs;
